require('./angulartics-google-analytics')
module.exports = 'angulartics.google.analytics'



//////////////////
// WEBPACK FOOTER
// ../node_modules/angulartics-google-analytics/lib/index.js
// module id = 552
// module chunks = 3